import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import CloseSVG from "../../assets/icons/close.svg";

import "./Modal.scss";

const Modal = ({ closeModal, children, className }) => {
	const modalRef = useRef(null);

	useEffect(() => {
		const listener = e => {
			if (!modalRef.current || modalRef.current.contains(e.target)) return;
			closeModal();
		};

		document.addEventListener("mousedown", listener);
		document.addEventListener("touchdown", listener);

		return () => {
			document.removeEventListener("mousedown", listener);
			document.removeEventListener("touchdown", listener);
		};
	}, [closeModal]);

	return (
		<div className={clsx("modal", className)} ref={modalRef}>
			<button className="modal__button" onClick={closeModal}>
				<CloseSVG className="modal__button--icon" />
			</button>
			{children}
		</div>
	);
};

Modal.propTypes = {
	closeModal: PropTypes.func.isRequired,
	children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]).isRequired,
	className: PropTypes.string,
};

Modal.defaultProps = {
	className: "",
};

export default Modal;
